import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appDate]',
  standalone: true,
})
export class DateDirective {
  // eslint-disable-next-line no-useless-escape
  onlyLettersRegex = /^[0-9\/]+$/;

  @HostListener('keypress', ['$event']) onKeypress(event: KeyboardEvent) {
    if (!this.onlyLettersRegex.test(event.key) || event.key === 'Dead' || event.key === '´') {
      event.preventDefault();
    }
  }
}
